import React from "react";
import styled from "styled-components";
import { Content } from "../Content";
import { GradientBox } from "../GradientBox";
import { Logo } from "../Logo";
import { DeviceWidth, useDeviceWidthQuery } from "../MediaQuery";
import { Navigation } from "../navigation/Navigation";
import { SizedBox } from "../SizedBox";
import { translation } from "../translations";
import { Header2 } from "../typography";

export const Header: React.FC = () => {
  const deviceWidth = useDeviceWidthQuery();

  const buildDesktopVariant = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        paddingTop: 16,
        paddingBottom: 40,
      }}
    >
      <Header1 fontSize={48}>{translation.appTitle}</Header1>
      <Logo width={280} />
    </div>
  );

  const buildMobileVariant = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        flexDirection: "column",
        width: 680,
        paddingTop: 40,
        paddingBottom: 42,
      }}
    >
      <Logo width={260} />
      <SizedBox height={48} />
      <Header2 color="white">{translation.appTitle}</Header2>
    </div>
  );

  const buildAppropriateVariant = () => {
    if (deviceWidth === DeviceWidth.desktop) {
      return buildDesktopVariant();
    } else {
      return buildMobileVariant();
    }
  };

  return (
    <header>
      <GradientBox>
        <Navigation />
        <Content>{buildAppropriateVariant()}</Content>
      </GradientBox>
    </header>
  );
};

const Header1 = styled.h1<{ fontSize: number }>`
  font-size: ${(props) => props.fontSize}px;
  font-weight: 700;
  color: white;
  margin: 0;
`;
